import { useIntl } from '@capsicum/common';
import { Snackbar } from '@capsicum/common-web';

export const V2FTMigrationSuccessSnackbar = () => {
	const { $t } = useIntl();

	return (
		<Snackbar
			description={$t('v2FTMigrationInitFlow.upgrade.notifications.migrationDone.description')}
			testID="v2FTMigration-success-snackbar"
			title={$t('v2FTMigrationInitFlow.upgrade.notifications.migrationDone.title')}
			variant="success"
		/>
	);
};
